module.exports = __webpack_public_path__ + "static/media/TransactionConnect.6bf6dc83.svg";